module.exports = __webpack_public_path__ + "img/3_uk.8b680dd6.svg";